export const SET_TIERS = "HR_SET_TIERS";
export const ADD_TIER = "HR_ADD_TIER";
export const EDIT_TIER = "HR_EDIT_TIER";
export const REMOVE_TIER = "HR_REMOVE_TIER";
